var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game"},[(_vm.gameStarted)?_c('GameBoard'):(_vm.game)?_c('GameSettings'):_c('div',[_vm._v("loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }